
import i18next from "i18next";

export const checkValueQ=(setting,permistionInv,type,oldVal)=>{
    if (permistionInv.SIM == false &&
        oldVal < 1 && type != 4 &&
        (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
            return 0;
        }else return 1;
};

export const getAlertValQ=(valueSafes,ibance,totValbef,perc)=>{
    alert(
        `
${i18next.t("forms:entered-qty-exceeds-stock")}
${i18next.t("forms:entered-total-qty")} : ${Number(totValbef) + (parseFloat(1) * parseFloat(perc))
        }
${i18next.t("forms:stock-balance")} : ${valueSafes.name} = ${parseInt(ibance)
        }
`
    );
    return 0;
};